import React, {useState, useEffect} from 'react'
import './index.css'
import './App.css'
import {textcontent} from './texts.js'
import firebase from './Firebase'

//MEDIA
import Rad from './assets/rad.png'
import FlagDE from './assets/de.png'
import FlagEN from './assets/en.png'
import { FiChevronRight } from 'react-icons/fi'

//Help

import sha256 from 'js-sha256'
import CryptoJS from 'crypto-js'
import HeaderStats from './HeaderStats'
import LastSolutions from './LastSolutions'

const App = () => {
    const [input, setInput] = useState('')
    const [validationStatus, setValidationStatus] = useState('unset')
    const [activeLanguage, setActiveLanguage] = useState('de')
    const [usersSolution, setUsersSolution] = useState('')

    const dehashed = "f2475e087314821743cac8cc3c734844f73de81f04d7cd5b3ac47eff9701557d";
    const enhashed = "b5ad121307b9c486471d1d2e45bbcfa70cf31125e2049c66f658bcf40016c84e";
    const resultde = "U2FsdGVkX18k7/pAJHBCe+XhiGpbT1dwX22P+w4Mq5Lq6atOBUidR5kDfhkYT655";
    const resulten = "U2FsdGVkX1+DFd1Iy7cA2kxHc5V0jDOfm9tZtZ91Z+hmG+LGazo0bH80KhmUF9BU";

    useEffect(() => {
        setValidationStatus('unset')
        setInput('')
        setUsersSolution('')
    }, [activeLanguage])

    const handleSubmit = e => {
        e.preventDefault();

        var inputcleaned = input.replace(" ","").toLowerCase() //damit "Rolle r = roller" wird -> Tippfehler etc.
        setUsersSolution(inputcleaned);
    }

    useEffect(() => {
        if(usersSolution) {
            const inputhashed = sha256(usersSolution);

            if( activeLanguage==="de" && inputhashed === dehashed) {
                setValidationStatus("success")
                incrementSuccess()
            } else {
                if(activeLanguage==="en" && inputhashed === enhashed) {
                    setValidationStatus("success")
                    incrementSuccess()
                } else {
                    setValidationStatus("fail")
                    decrementSuccess()
                    addSolution()
                }
            }
        }
    }, [usersSolution])

    const addSolution = () => {
        firebase.firestore().collection('solutions').add({
            solution: usersSolution,
            time: firebase.firestore.FieldValue.serverTimestamp()
        })
    }

    const incrementSuccess = () => {
        firebase.firestore().collection('stats').doc('solutions').update({
            successful: firebase.firestore.FieldValue.increment(1), 
            lastsolution: firebase.firestore.FieldValue.serverTimestamp()
        })
    }

    const decrementSuccess = () => {
        firebase.firestore().collection('stats').doc('solutions').update({
            fails: firebase.firestore.FieldValue.increment(1)
        })
    }

    const renderValidation = () => {
        switch (validationStatus) {
            case "success":
                var encryptedcoords = activeLanguage === "de" ? resultde : resulten;
                var bytes  = CryptoJS.AES.decrypt(encryptedcoords, usersSolution.replace(" ","").toLowerCase());
                var coords = bytes.toString(CryptoJS.enc.Utf8);
                return(
                    <div className='solved-wrapper'>
                        <p>{textcontent.validationsuccess[activeLanguage]}</p>
                        <p className='sol-coords'> {coords}</p>
                        <LastSolutions activelan={activeLanguage} />
                    </div>
                )
            case "fail":
                return(
                    <p className='failed-msg'>{textcontent.validationfail[activeLanguage]}</p>
                );
            case "unset":
                return(
                    <p>{textcontent.validationunset[activeLanguage]}</p>
                )
            default:

            break;
        }
    }

    return (
        <div className="app">
            <div className="header">
                <a href="https://www.geocaching.com/geocache/GC9DMZ1_das-rad" className="gc-link" target="_blank">
                GC9DMZ1
                </a>
                <div className="lan-switch">
                    <img src={FlagDE} className={"flag "+ (activeLanguage === "de" && "active-flag")} onClick={() => setActiveLanguage('de')}/>
                    <img src={FlagEN} className={"flag "+ (activeLanguage === "en" && "active-flag")} onClick={() => setActiveLanguage('en')}/>
                </div>
            </div>
            <div className="hero">
                <h1 className="title">{textcontent.heading[activeLanguage]}</h1>
                <img src={Rad} className="wheel-hero" alt="Das Rad dreht sich" />
                <HeaderStats />
            </div>
            <div className="checker-wrapper">
                <form className="checker" onSubmit={e => handleSubmit(e)}>
                    <input placeholder={textcontent.inputplaceholder[activeLanguage]} value={input} onChange={e => setInput(e.target.value)}></input>
                    <button type="submit"><FiChevronRight /></button>
                </form>
            </div>
            <div className="validation-msg">
                {renderValidation()}
            </div>
        </div>
    )
}

export default App